import { computeFiveNumberSummary } from './computeFiveNumberSummary';

export const computeDescriptiveSummary = values => {
  if (!Array.isArray(values) || values.length === 0) return null;
  const mean = values.reduce((sum, value) => sum + value, 0) / values.length;
  const variance = values.reduce((sum, value) => sum + ((value - mean) ** 2), 0) / values.length;
  const quartiles = computeFiveNumberSummary(values);
  return {
    mean,
    sd: Math.sqrt(variance),
    median: quartiles.median,
    q1: quartiles.q1,
    q3: quartiles.q3,
  };
};
